import React from 'react';
import { Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const sectionHeadingSx = {
  mt: 3,
  mb: 1,
  fontSize: '1.125rem',
  fontWeight: 600,
  color: 'text.primary',
};

const bodySx = { mb: 2, color: 'text.primary' };

export default function KayttoehdotContent({
  linkSx = { color: 'secondary.main' },
  showUpdatedDate = true,
  onOpenPrivacy,
}) {
  return (
    <>
      {showUpdatedDate && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Päivitetty 31.05.2024
        </Typography>
      )}

      <Typography variant="body1" sx={bodySx}>
        Tervetuloa käyttämään Pohjolan Rahoitusvertailu Oy:n (jäljempänä &quot;Pohjolan Rahoitusvertailu&quot;)
        verkkopalvelua. Käyttämällä tätä verkkopalvelua hyväksyt seuraavat käyttöehdot. Mikäli et
        hyväksy näitä ehtoja, pyydämme sinua olemaan käyttämättä palveluamme.
      </Typography>

      <Typography component="h2" variant="h3" sx={sectionHeadingSx}>
        Palvelun käyttö
      </Typography>
      <Typography variant="body1" sx={bodySx}>
        Verkkopalvelu on tarkoitettu auttamaan käyttäjiä löytämään ja vertailemaan erilaisia
        rahoitusratkaisuja. Pohjolan Rahoitusvertailu tarjoaa tietoa rahoitusvaihtoehdoista, mutta ei
        suoraan tarjoa rahoituspalveluita.
      </Typography>
      <Typography variant="body1" sx={bodySx}>
        Palvelun käyttäjä hyväksyy, että pankit ja rahoitusyhtiöt voivat olla yhteydessä myös suoraan
        rahoituksen hakijaan tarjotessaan rahoitusratkaisua tai pyytäessään lisätietoja rahoituksen
        tarpeen tai yhtiön luottokelpoisuuden selvittämiseksi. Palvelun käyttäjä hyväksyy, että pankit
        ja rahoitusyhtiöt voivat hakea tietoja kulloinkin vallitsevan luottopolitiikkansa mukaisesti
        yhtiöstä ja yhtiön edustajasta Suomen Asiakastiedon ja muiden luottotietoyhtiöiden kaikille
        avoimista ja yksityisistä rekistereistä ja järjestelmistä, kuten Suomen Asiakastiedon muiden
        yritysluottojen ja taloudellisen tilanteen selvittämistä varten perustetusta järjestelmästä.
      </Typography>

      <Typography component="h2" variant="h3" sx={sectionHeadingSx}>
        Vastuunrajoitus
      </Typography>
      <Typography variant="body1" sx={bodySx}>
        Pohjolan Rahoitusvertailu ei takaa verkkopalvelussa tarjottujen tietojen täydellisyyttä,
        ajantasaisuutta tai tarkkuutta. Verkkopalvelun sisältö on tarkoitettu ainoastaan
        informatiivisiin tarkoituksiin, eikä se muodosta oikeudellista, taloudellista tai muuta
        ammatillista neuvontaa.
      </Typography>
      <Typography variant="body1" sx={bodySx}>
        Pohjolan Rahoitusvertailu ei ole vastuussa mistään välittömistä, välillisistä, satunnaisista,
        erityisistä tai seurannaisvahingoista, jotka johtuvat verkkopalvelun käytöstä tai siihen
        liittyvästä toiminnasta, vaikka Pohjolan Rahoitusvertailulle olisi ilmoitettu tällaisten
        vahinkojen mahdollisuudesta.
      </Typography>
      <Typography variant="body1" sx={bodySx}>
        Pohjolan Rahoitusvertailu ei ole vastuussa siitä, minkä rahoituspalvelun käyttäjä valitsee
        verkkopalvelussa esitettyjen tietojen perusteella. Käyttäjä on itse vastuussa kaikista
        päätöksistään ja toimistaan, jotka perustuvat verkkopalvelun kautta saatuihin tietoihin.
      </Typography>
      <Typography variant="body1" sx={bodySx}>
        Pohjolan Rahoitusvertailu ei ole vastuussa mistään mahdollisista tappioista, jotka aiheutuvat
        palvelun kautta valitun tai suositellun rahoitusyhtiön suorasta tai epäsuorasta toiminnasta.
      </Typography>

      <Typography component="h2" variant="h3" sx={sectionHeadingSx}>
        Käyttäjän vastuut
      </Typography>
      <Typography variant="body1" sx={bodySx}>
        Käyttäjä sitoutuu käyttämään verkkopalvelua lain ja hyvien tapojen mukaisesti. Käyttäjä ei saa
        käyttää palvelua laittomaan tai sopimattomaan tarkoitukseen, eikä häiritä palvelun toimintaa
        millään tavalla.
      </Typography>

      <Typography component="h2" variant="h3" sx={sectionHeadingSx}>
        Henkilötietojen käsittely
      </Typography>
      <Typography variant="body1" sx={bodySx}>
        Henkilötietojen käsittelyä koskevat tiedot löytyvät erillisestä{' '}
        {onOpenPrivacy ? (
          <Link
            component="button"
            type="button"
            onClick={onOpenPrivacy}
            sx={{ ...linkSx, verticalAlign: 'baseline', fontSize: 'inherit' }}
          >
            tietosuojaselosteesta
          </Link>
        ) : (
          <Link component={RouterLink} to="/tietosuojaseloste" sx={linkSx}>
            tietosuojaselosteesta
          </Link>
        )}
        , joka on saatavilla verkkopalvelussa.
      </Typography>

      <Typography component="h2" variant="h3" sx={sectionHeadingSx}>
        Muutokset käyttöehtoihin
      </Typography>
      <Typography variant="body1" sx={bodySx}>
        Pohjolan Rahoitusvertailu pidättää oikeuden muuttaa näitä käyttöehtoja milloin tahansa ilman
        ennakkoilmoitusta. Käyttöehtoihin tehdyt muutokset tulevat voimaan, kun ne on julkaistu
        verkkopalvelussa.
      </Typography>

      <Typography component="h2" variant="h3" sx={sectionHeadingSx}>
        Sovellettava laki ja riitojen ratkaisu
      </Typography>
      <Typography variant="body1" sx={bodySx}>
        Näihin käyttöehtoihin sovelletaan Suomen lakia. Kaikki näihin käyttöehtoihin tai verkkopalvelun
        käyttöön liittyvät erimielisyydet ratkaistaan ensisijaisesti neuvotteluin. Mikäli neuvottelut
        eivät johda sopimukseen, riidat ratkaistaan Helsingin käräjäoikeudessa.
      </Typography>

      <Typography component="h2" variant="h3" sx={sectionHeadingSx}>
        Yhteystiedot
      </Typography>
      <Typography variant="body1" sx={bodySx}>
        Mikäli sinulla on kysyttävää näistä käyttöehdoista, voit ottaa meihin yhteyttä sähköpostitse
        osoitteeseen{' '}
        <Link href="mailto:info@rahoituskanava.fi" sx={linkSx}>
          info@rahoituskanava.fi
        </Link>
        .
      </Typography>
    </>
  );
}
